import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { IEventEventType } from "../../models/event/eventEventType";
import { EventTypeNode, IEventTypeNode } from "../../models/event/eventTypeNode";
import { SelectEventTypesDialog } from "./selectEventTypesDialog";

//EventEventTypeListLine
//***************************************************************
export interface IEventEventTypeListLineProp {
    eventTypeNode: IEventTypeNode;
}

export class EventEventTypeListLine extends React.Component<IEventEventTypeListLineProp, {}> {
    render() {
        const props = this.props;
        return (
            <div className="line">
                <div className="row">
                    <div className={"col col-12"}>
                        <div className="singleLine">{props.eventTypeNode.getPathName()}</div>
                    </div>
                </div>
            </div>
        );
    }
}

//EventEventTypeList
//***************************************************************
export interface IEventEventTypeListProp {
    isReadOnly: boolean;
    title: string;
    info: string;
    selectTitle: string;
    eventTypeCategory: number;
    eventEventTypes: IEventEventType[];
    eventTypeNodes: IEventTypeNode[];
    onEditEventEventTypes: (eventTypeIds: string[], eventTypeCategory: number) => void;
}

interface IEventEventTypeListState {
    showEditEventTypesDialog: boolean;
}

export class EventEventTypeList extends React.Component<IEventEventTypeListProp, IEventEventTypeListState> {
    constructor(props) {
        super(props);
        this.state = { showEditEventTypesDialog: false };
    }

    handleEditClick = () => {
        this.setState({
            showEditEventTypesDialog: true
        });
    };

    handleEditEventTypesDialogOk = (ids: string[]) => {
        this.props.onEditEventEventTypes(ids, this.props.eventTypeCategory);
        this.setState({
            showEditEventTypesDialog: false
        });
    };

    handleEditEventTypesDialogCancel = () => {
        this.setState({
            showEditEventTypesDialog: false
        });
    };

    render() {
        const props = this.props;
        const selectedEventTypeNodes = EventTypeNode.getEventTypeNodesFromNodesByIds(props.eventTypeNodes, props.eventEventTypes.map(i => i.eventTypeId));
        return (
            <div>
                <div className="fullLeft">
                    <label className="control-label">{this.props.title}</label>
                    <ToolButton
                        tooltip={Translations.Edit}
                        disabled={props.isReadOnly}
                        classes={"btn btn-tool right mono round edit"}
                        onClick={this.handleEditClick}
                    />
                </div>
                {!props.isReadOnly && props.eventEventTypes.length === 0 &&
                    <div className="fullLeft">
                        <div className="alert alert-info" role="alert">
                            {props.info}
                        </div>
                    </div>
                }
                <div className="fullLeft lineContainer eventEventTypes">
                    {selectedEventTypeNodes.map((eventTypeNode) =>
                        <EventEventTypeListLine
                            key={eventTypeNode.id}
                            eventTypeNode={eventTypeNode}
                        />
                    )}
                </div>
                {this.state.showEditEventTypesDialog &&
                    <SelectEventTypesDialog
                        title={props.selectTitle}
                        eventTypeNodes={props.eventTypeNodes}
                        checkedIds={props.eventEventTypes.map(i => i.eventTypeId)}
                        onOk={this.handleEditEventTypesDialogOk}
                        onCancel={this.handleEditEventTypesDialogCancel}
                    />
                }
            </div>
        );
    }
}